import moment from "moment";
import { getWiSAEyeReport } from "../../api/config";
import Spinner from "../../components/Spinner";
import { useFetch } from "../../hooks/useFetch";

import styles from "./styles.module.scss";
import { useNavigate } from "react-router-dom";
import { WiSAEye } from "../../interfaces/be.interfaces";

const WiFiAnalyzerChart = () => {
  const navigate = useNavigate();

  // Get records of WiSA Eye data collections
  const { data: response, loading: reportLoading } = useFetch<{ data: WiSAEye[] }>({
    url: getWiSAEyeReport,
    runOnMount: true,
  });

  return (
    <div className={styles.pageContainer}>
      <div className={styles.tableResponsive}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th className={styles.center}>Collection ID</th>
              <th className={styles.center}>Vendor ID</th>
              <th className={styles.center}>User Name</th>
              <th className={styles.center}>Collection Time</th>
              <th className={styles.center}>Action</th>
            </tr>
          </thead>
          <tbody>
            {reportLoading ? (
              <tr>
                <td colSpan={5}>
                  <Spinner />
                </td>
              </tr>
            ) : response?.data?.length ? (
              response?.data?.map((item) => {
                return (
                  <tr key={item.collection_id}>
                    <td className={styles.center}>{item?.collection_id}</td>
                    <td className={styles.center}>{item.user?.vendor_id}</td>
                    <td className={styles.center}>{item.user?.name}</td>
                    <td className={styles.center}>{moment(item.created_at).format("DD/MM/YYYY hh:mm A")}</td>
                    <td className={styles.center}>
                      <button className={styles.btn} onClick={() => navigate(`/wisa-eye/${item.collection_id}`)}>
                        View Data
                      </button>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={5}>
                  <div className={`${styles.emptyPage} d-flex justify-content-center align-item-center`}>
                    <span className={styles.noDataFound}>No WiSA Eye Data Found</span>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default WiFiAnalyzerChart;
